import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Logo } from "@/components/Logo";
import { ShieldCheck } from "lucide-react";

const INFO = [
  { label: "Application Name", value: "SGBINOXE Care" },
  { label: "Version", value: "1.0" },
  { label: "Release Date", value: "June 2026" },
  { label: "Environment", value: "Production" },
];

export default function About() {
  return (
    <DashboardLayout title="About">
      <div className="max-w-2xl">
        <div className="rounded-2xl border border-white/[0.06] bg-[#141414] p-8" data-testid="about-panel">
          <div className="mb-6 h-9"><Logo className="h-9" showText /></div>
          <p className="text-sm leading-relaxed text-neutral-400">
            SGBINOXE Care is the internal CRM and installation-certificate platform for SGBINOXE installers —
            issue premium certificates, activate bottle credits, and stay on top of customer follow-ups.
          </p>
          <div className="mt-8 divide-y divide-white/[0.05]">
            {INFO.map((i) => (
              <div key={i.label} className="flex items-center justify-between py-3" data-testid="about-row">
                <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-600">{i.label}</span>
                <span className="text-sm font-medium text-white">{i.value}</span>
              </div>
            ))}
          </div>
          <div className="mt-8 flex items-center gap-2 rounded-xl border border-emerald-500/20 bg-emerald-500/[0.06] px-4 py-3 text-sm text-emerald-400">
            <ShieldCheck className="h-4 w-4" /> Version 1.0
          </div>
          <p className="mt-6 text-xs text-neutral-600">© {new Date().getFullYear()} SGBINOXE. All rights reserved.</p>
        </div>
      </div>
    </DashboardLayout>
  );
}
